import { useQuery } from '@tanstack/react-query'

export interface PortraitListQueryOptions {
  /** False holds the request back (the Portraits tray waits until its dropdowns are in use). */
  enabled?: boolean
}

/**
 * A portraits dropdown list (grades, homerooms, custom groups): fetched once and kept for five
 * minutes, with no retry and no refetch on focus, so a failed list stays failed until the user
 * asks again instead of silently re-requesting.
 */
export function usePortraitListQuery<T>({
  queryKey,
  queryFn,
  enabled = true,
}: {
  queryKey: readonly unknown[]
  queryFn: () => Promise<T[]>
} & PortraitListQueryOptions) {
  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
